import InviteInvalid from "@/views/Invite/page-scene/Invite-invalid.vue";
import InviteSuccess from "@/views/Invite/page-scene/Invite-success.vue";
import activateAccount from "@/views/Invite/page-scene/activate-account.vue";
import joinSuccess from "@/views/Invite/page-scene/join-success.vue";
import invite from "@/service/invite";
export default {
  components: {
    InviteInvalid,
    InviteSuccess,
    activateAccount,
    joinSuccess
  },
  data() {
    return {
      type: "activateAccount",
      InviteSceneMap: {
        activateAccount,
        InviteSuccess,
        InviteInvalid,
        joinSuccess
      },
      inviteInfo: {
        createUser: "",
        createUserName: "",
        email: "",
        inviteType: null,
        mobile: "",
        unitId: "",
        unitName: "",
        userName: "",
        valid: true,
        needApprove: null
      },
      needApprove: null
    };
  },
  computed: {
    InviteScene() {
      return this.InviteSceneMap[this.type];
    }
  },
  methods: {
    async validInviteLink() {
      let {
        inviteCode
      } = this.$route.query;
      let res = await invite.validInviteLink({
        inviteCode
      });
      let {
        data: {
          result,
          retVal
        }
      } = res;
      if (result === 0) {
        let {
          valid
        } = retVal;
        if (valid) {
          Object.assign(this.inviteInfo, retVal);
          this.type = "activateAccount";
        } else {
          this.type = "InviteInvalid";
        }
      } else {
        this.type = "InviteInvalid";
      }
    },
    next(flag) {
      this.type = flag ? "joinSuccess" : "InviteSuccess";
    }
  },
  mounted() {
    this.validInviteLink();
  }
};